import { useMemo } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import clsx from 'clsx'
import { isNumber } from 'lodash'
import {
  ColorsEnum,
  Mozgoteka,
  MozgotekaContext,
  useMozgotekaClasses,
} from '../mozgoteka'
import ResultColor from './ResultColor.enum'

interface ResultProps {
  status?: number | React.ReactNode
  title: string
  // subTitle?: string
  description?: string
  extra?: React.ReactNode
  variant?: ResultColor
}

const Result = (props: ResultProps) => {
  const {
    status,
    title,
    // subTitle,
    description,
    extra,
    variant: variantProp = ResultColor.BlueRevert,
  } = props

  const MProps = useMemo(() => {
    const parts = variantProp?.split('-')
    let variant = (parts?.[0] as ColorsEnum) ?? ColorsEnum.Blue
    const revert = parts?.[1] === 'revert'
    switch (variant) {
      case 'blue':
        variant = ColorsEnum.Blue
        break
      case 'pink':
        variant = ColorsEnum.Pink
        break
      case 'green':
        variant = ColorsEnum.Green
        break
      case 'yellow':
        variant = ColorsEnum.Yellow
        break
    }
    return { variant, revert }
  }, [variantProp])

  const mozgotekaClasses = useMozgotekaClasses(MProps)

  return (
    <MozgotekaContext.Provider value={mozgotekaClasses}>
      <Stack
        className={clsx(mozgotekaClasses.background, mozgotekaClasses.text)}
        alignItems="center"
        justifyContent="center"
        p={2}
        spacing={4}
        sx={{ flexGrow: 1, textAlign: 'center' }}
      >
        <Mozgoteka
          className="px-3 py-2 max-w-[160px]"
          revert
          signet
          variant="pink"
        />
        {/* {subTitle && (
          <Typography color="primary" className="font-fontWeightMedium mb-2">
            {subTitle}
          </Typography>
        )} */}
        <Typography className={mozgotekaClasses.text} variant="h3">
          {isNumber(status) ? `${status} - ` : ''}
          {title}
        </Typography>
        {description && (
          <Typography
            className={mozgotekaClasses.text}
            variant="h5"
            dangerouslySetInnerHTML={{
              __html: description.replace(/([.?]\s)/g, '$1<br />'),
            }}
          />
        )}
        {extra && <Box className="mt-3">{extra}</Box>}

        {status !== undefined && !isNumber(status) && (
          <Box sx={{ display: { xs: 'none', lg: 'block' } }}>{status}</Box>
        )}
      </Stack>
    </MozgotekaContext.Provider>
  )
}

export default Result
